/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// oxlint-disable sort-keys
// Markdown inputs shared by the Response unit and Playwright tests.
// Images use data URIs so tests do not depend on the network.

const PIXEL_SVG =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjMDE0MDYzIi8+PC9zdmc+';

export const responseFixtures = {
  basicFormatting: `# Heading 1

## Heading 2

A paragraph with **bold**, *italic* and \`inline code\`.

> A blockquote

---

- Item 1
- Item 2

1. First
2. Second`,

  links: `- [Absolute link](https://neo4j.com/docs/)
- [Fragment with underscore](https://neo4j.com/docs/aura/#_what_is_aura)
- [Relative link](/docs/getting-started)
- [Mail link](mailto:hello@example.com)
- [Script link](javascript:alert(1))
- Bare URL https://neo4j.com/product/`,

  image: `![Data image](${PIXEL_SVG})`,

  table: `| Item | In Stock | Price |
| :--- | :------: | ----: |
| Hat  |   True   | 23.99 |
| Tee  |  False   | 19.99 |`,

  codeSupported: `\`\`\`cypher
MATCH (n:Movie) RETURN n.title LIMIT 10
\`\`\``,

  codeUnknownLanguage: `\`\`\`brainfuck
++++++++[>++++<-]>.
\`\`\``,

  mermaid: `\`\`\`mermaid
graph TD
  A[Start] --> B[End]
\`\`\``,

  math: `Inline math $x^2 + y^2 = z^2$ in a sentence.

$$
E = mc^2
$$`,

  rawHtml: `Before <b>bold html</b> after.

<script>window.hasNdlResponseXss = true;</script>

<img src="x" onerror="window.hasNdlResponseXss = true" alt="html image" />`,

  clobbering: `<a id="x" name="ndl-host-link" href="https://neo4j.com/">raw link</a> <img id="ndl-host-logo" name="ndl-host-image" src="/raw-image.png" alt="raw image" />

<h2 id="ndl-host-title">Raw heading</h2>

A footnote reference[^1].

[^1]: The footnote.`,

  incompleteLink: `Read more in [the docs](https://neo4j.com/do`,

  incompleteImage: `Look at this ![Partial image](https://exa`,

  incompleteBold: `This is **unfinished bold`,
} as const;

export type ResponseFixtureName = keyof typeof responseFixtures;
